const GroupIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="37" viewBox="0 0 43 37" fill="none">
      <path
        d="M1 35.6976C1 27.8365 7.36983 21.4879 15.2096 21.4879C23.0494 21.4879 29.4193 27.8578 29.4193 35.6976H1Z"
        fill="white"
      />
      <path
        d="M14.9746 17.9723C19.6169 17.9723 23.3681 14.2211 23.3681 9.57876C23.3681 4.93642 19.5962 1.18524 14.9746 1.18524C10.353 1.18524 6.58105 4.93642 6.58105 9.57876C6.58105 14.2211 10.3322 17.9723 14.9746 17.9723Z"
        fill="white"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.533 35.6976H1C1 27.8365 7.36984 21.4879 15.2096 21.4879C16.9352 21.4879 18.5969 21.8075 20.1308 22.3614"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6257 35.6957V31.0515"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.7303 21.4002H25.0094C24.5194 21.4002 24.0507 21.592 23.7098 21.9328C23.369 22.2737 23.1772 22.7424 23.1772 23.2323V34.2677C23.1772 34.7577 23.369 35.2264 23.7098 35.5672C24.0507 35.9081 24.5194 36.0998 25.0094 36.0998H25.5207L40.1564 21.4641C40.0072 21.4215 39.8794 21.3789 39.7303 21.3789V21.4002Z"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1553 23.2352C23.1553 22.7452 23.347 22.2765 23.6879 21.9356C24.0287 21.5948 24.4974 21.403 24.9874 21.403H39.7083C40.1983 21.403 40.667 21.5948 41.0079 21.9356C41.3487 22.2765 41.5405 22.7452 41.5405 23.2352V34.2705C41.5405 34.7605 41.3487 35.2292 41.0079 35.5701C40.667 35.9109 40.1983 36.1027 39.7083 36.1027H24.9874C24.4974 36.1027 24.0287 35.9109 23.6879 35.5701C23.347 35.2292 23.1553 34.7605 23.1553 34.2705V23.2352Z"
        fill="white"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.7571 21.4017L28.6731 19.5696C28.8649 19.0157 29.2483 18.5257 29.7383 18.1848C30.2283 17.844 30.8248 17.6948 31.4213 17.7161H33.2535C33.85 17.6948 34.4465 17.844 34.9365 18.1848C35.4264 18.5257 35.8099 18.9944 36.0016 19.5696L36.9177 21.4017"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.9999 28.8571V33.7948C41.9999 35.1271 40.8974 36.1837 39.5192 36.1837H25.617C24.9968 36.1837 24.434 35.9655 23.9976 35.5865C23.4693 35.173 23.1362 34.5299 23.1362 33.7948V28.8571H41.9999Z"
        fill="#29A1A3"
      />
      <path
        d="M23.1553 28.776H41.5618"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1553 23.2352C23.1553 22.7452 23.347 22.2765 23.6879 21.9356C24.0287 21.5948 24.4974 21.403 24.9874 21.403H39.7083C40.1983 21.403 40.667 21.5948 41.0079 21.9356C41.3487 22.2765 41.5405 22.7452 41.5405 23.2352V34.2705C41.5405 34.7605 41.3487 35.2292 41.0079 35.5701C40.667 35.9109 40.1983 36.1027 39.7083 36.1027H24.9874C24.4974 36.1027 24.0287 35.9109 23.6879 35.5701C23.347 35.2292 23.1553 34.7605 23.1553 34.2705V23.2352Z"
        stroke="#218182"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7315 31.9333C16.7383 31.9333 16.7417 31.9416 16.7371 31.9467C15.749 33.0315 14.8345 32.9429 13.9398 32.1688C13.7752 32.0264 13.7028 31.8075 13.7274 31.5913L14.8274 21.9255H15.5926L16.7315 31.9333Z"
        fill="#29A1A3"
      />
    </svg>
  );
};

export default GroupIcon;
